import React from 'react';

import { MapMenu } from '../map/map-menu';
import { GameContext } from '../../../contexts/game';
import { Menu } from '../../../types/facilitator/map-menu';
import { roundingDecimalNumber } from '../../../utils/number';

export const TeamsMenu: React.FC<{
  search: string;
  selectedMenu: Menu | undefined;
  setSelectedMenu: (value: React.SetStateAction<Menu | undefined>) => void;
}> = ({ search, selectedMenu, setSelectedMenu }) => {
  const [gameState] = React.useContext(GameContext);

  const teams: Menu[] = React.useMemo(
    () =>
      gameState?.gameState?.teams
        ?.map((team) => ({
          name: team.name ?? '',
          code: team.code ?? '',
          type: 'team' as 'team',
          score: roundingDecimalNumber(team?.score ?? 0, 2) ?? ''
        }))
        ?.sort((a, b) => b.score - a.score) || [],
    [gameState.gameState?.teams]
  );

  return (
    <div className="list-group w-100 bg-transparent d-flex">
      {teams
        ?.filter((x) => x.name?.toLowerCase()?.includes(search?.toLowerCase()))
        ?.map((menu) => (
          <MapMenu
            key={menu.code}
            menu={menu}
            selectedMenu={selectedMenu}
            onChange={(v) => setSelectedMenu(v)}
          />
        ))}
    </div>
  );
};
